import { ChangeDetectionStrategy, Component, Signal, computed, input } from '@angular/core';
import {
    CeButtonComponent,
    CeIconComponent,
    CeParameterListImports,
    CePillComponent,
} from '@kempower-nx-workspace/shared/kp-design-system';
import { EnrichedFrontendNotification, GetNotificationEmailSentTimestampResponse } from '../../data-access/notification-data/notification-data.service';

@Component({
    selector: 'ce-notification-subscription-about-to-expire-content',
    imports: [
        CeButtonComponent,
        CeIconComponent,
        CeParameterListImports,
        CePillComponent,
    ],
    templateUrl: './notification-subscription-about-to-expire-content.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationSubscriptionAboutToExpireContentComponent {
    notification = input.required<EnrichedFrontendNotification>();
    emailTimestamp = input<GetNotificationEmailSentTimestampResponse | undefined>();
    detailsInClassicUrl = input.required<string>();
    linkLabel = input.required<string>();

    tenantName = computed(() => this.notification().events[0]?.metadata?.['tenantName'] ?? '');
    licenseNumber = computed(() => this.notification().events[0]?.metadata?.['licenseNumber'] ?? '');
    daysUntilExpiration = computed(() => this.notification().events[0]?.metadata?.['daysUntilExpiration']);

    isSubscriptionExpired: Signal<boolean> = computed(() => {
        const daysUntilExpiration = this.daysUntilExpiration();
        return daysUntilExpiration !== undefined && daysUntilExpiration < 0;
    });

    subscriptionStartDate: Signal<string> = computed(() => {
        const startDate = this.notification().events[0]?.metadata?.['startDate'];
        return startDate ? this.#formatDateWithoutTime(startDate) : '';
    });

    subscriptionExpiryDate: Signal<string> = computed(() => {
        const expiryDate = this.notification().events[0]?.metadata?.['expirationDate'];
        return expiryDate ? this.#formatDateWithoutTime(expiryDate) : '';
    });

    licenseName: Signal<string> = computed(() => {
        const rawLicenseName = this.notification().events[0]?.metadata?.['licenseName'];
        if (!rawLicenseName) return '';
        return rawLicenseName.replace(/^ChargEye\s*/i, '').trim();
    });

    #formatDateWithoutTime(dateString: string): string {
        const date = new Date(dateString);
        const formatted = date.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            timeZone: 'UTC',
        });
        return formatted.replace(/ (\d{4})$/, ', $1');
    }
}
